import { Action, createReducer, on } from '@ngrx/store';
import { ErrorModel } from '@classifieds-sell/datalayer';
import {
    setRouterStepId,
    setRouterStepInfo,
    updateSteps,
    updateRouterStateAction
} from './router.actions';
import { IRouterState } from './router.models';

export const ROUTER_FEATURE_KEY = 'router';

export interface RouterState extends IRouterState {
    error?: ErrorModel | null;
}

export interface RouterPartialState {
    readonly [ROUTER_FEATURE_KEY]: RouterState;
}

export const initialRouterState: RouterState = {
    id: null,
    queryParams: {},
    params: {},
    url: '',
    fullUrl: '',
    fragment: null,
    data: {
        categoryId: 0
    }
};

const routeReducer = createReducer(
    initialRouterState,
    on(updateRouterStateAction, (state, { router }) => ({
        ...state,
        ...router,
        data: {
            ...state.data,
            ...router.data,
            stepInfo: {
                ...state.data.stepInfo,
                ...router.data.stepInfo
            }
        }
    })),
    on(setRouterStepInfo, (state, { stepInfo }) => ({
        ...state,
        data: {
            ...state.data,
            stepInfo: stepInfo
        }
    })),
    on(setRouterStepId, (state, { stepId }) => ({
        ...state,
        data: {
            ...state.data,
            stepInfo: {
                ...state.data.stepInfo,
                stepId: stepId
            }
        }
    })),
    on(updateSteps, (state, { steps }) => ({
        ...state,
        data: {
            ...state.data,
            steps: steps
        }
    }))
);

export function routerReducer(state: RouterState | undefined, action: Action) {
    return routeReducer(state, action);
}
